import { IPoi } from '../poi-model/poi';
import { PresenterBase } from './presenter-base';
import { type BasePlaceEntity } from '@placer-ui/types';

function formatAddress(
  formattedAddress: string | undefined,
  subCategory: string,
  group: string | undefined,
  cityName: string,
  stateCode: string | undefined | null,
  stateName: string | undefined | null,
) {
  let addressLabel = formattedAddress ?? '';
  if (group === 'Region' && subCategory !== 'Street') {
      if (subCategory === 'Country' || (!cityName && stateName)) {
        addressLabel= stateName!;
      } else if (stateCode && stateName) {
        addressLabel= `${cityName}, ${stateCode}`;
      }
  }
  return addressLabel;
}

export const getAddressLabel = (poi: BasePlaceEntity) => {
  const subCategory = poi.category_info.sub_category;
  const address = poi.address;

  let addressLabel = poi?.address?.formatted_address || '';

  const stateCode = address.state_code;
  const stateName = address.state;
  const cityName = address.city;

  return formatAddress(addressLabel, subCategory, poi.category_info.group, cityName, stateCode, stateName);
};

export class ComplexPresenter extends PresenterBase {
  getShortAddress(poi: IPoi): string {
    const address = poi.getAddress();
    const categoryInfo = poi.getCategoryInfo();
    const group = categoryInfo.group.get();
    const subCategory = categoryInfo.subCategory.get();
    const cityName = address.city.get();
    const stateCode = address.stateCode.get();
    const stateName = address.state.get();

    return formatAddress(super.getShortAddress(poi), subCategory, group, cityName, stateCode, stateName);
  }

}